/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AvatarPersona as AvatarPersona,
  rec_CalendarioFecha as CalendarioFecha,
  rec_Componente_KD_75_68 as Componente_KD_75_68,
  rec_HD as HD,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_UD as UD,
  rec_VD as VD,
  rec_WD as WD,
  rec__S as _S,
  rec_dS as dS,
  rec_gS as gS,
  rec_kx as kx,
  rec_ra as ra,
  rec_wr as wr,
} from "../../runtime/index.jsx";
export function SelectorFechaHora({
  value: e,
  onChange: t,
  min: n,
  max: r,
  disabled: i = !1,
  placeholder: a = `Elegí fecha y hora`,
  className: o = ``,
  id: s,
}) {
  let [c, l] = (0, React.useState)(!1),
    { fecha: u, hora: f, minuto: p } = UD(e),
    [m, h] = (0, React.useState)(() => gS(u) ?? new Date()),
    g = (0, React.useRef)(null);
  ((0, React.useEffect)(() => {
    let e = gS(u);
    c && e && h(e);
  }, [c]),
    kx(
      c,
      g,
      (0, React.useCallback)(() => l(!1), []),
    ));
  let _ = (e) => (n && e < n.split(`T`)[0]) || (r && e > r.split(`T`)[0]);
  function v(e) {
    _(e) || t(`${e}T${f && p ? `${f}:${p}` : VD}`);
  }
  function y(e, n) {
    t(`${u || dS(new Date())}T${e}:${n}`);
  }
  let b = Array.from(
      {
        length: 24,
      },
      (e, t) => WD(t),
    ),
    x = Array.from(
      {
        length: 60 / HD,
      },
      (e, t) => WD(t * HD),
    ),
    S = u ? `${_S(u)}${f ? `, ${f}:${p}` : ``}` : a;
  return (
    <div
      className={`relative ${o}`}
      ref={g}
      children={[
        <button
          type={`button`}
          id={s}
          disabled={i}
          aria-label={u ? `${S}. Cambiar` : a}
          onClick={() => l((e) => !e)}
          className={`flex w-full items-center justify-between gap-2 rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm outline-none transition focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg) disabled:cursor-not-allowed disabled:opacity-60`}
          children={[
            <span
              className={`truncate ${u ? `text-(--text-h)` : `text-(--text)/70`}`}
              children={S}
            />,
            <span
              className={`flex shrink-0 items-center gap-1`}
              children={[
                u && !i && (
                  <span
                    role={`button`}
                    tabIndex={0}
                    aria-label={`Quitar fecha`}
                    onClick={(e) => {
                      (e.stopPropagation(), t(``));
                    }}
                    onKeyDown={(e) => {
                      (e.key === `Enter` || e.key === ` `) &&
                        (e.preventDefault(), e.stopPropagation(), t(``));
                    }}
                    className={`rounded p-0.5 text-(--text) hover:text-(--error)`}
                    children={(0, JSXRuntime.jsx)(ra, {
                      className: `h-3.5 w-3.5`,
                    })}
                  />
                ),
                (0, JSXRuntime.jsx)(wr, {
                  className: `h-4 w-4 text-(--text)`,
                }),
              ]}
            />,
          ]}
        />,
        c && (
          <AvatarPersona
            anclaRef={g}
            className={`min-w-72 rounded-2xl border border-(--border) bg-(--bg) p-3 shadow-2xl`}
            children={[
              <CalendarioFecha
                mesRef={m}
                setMesRef={h}
                value={u}
                onElegir={v}
                fueraDeRango={_}
              />,
              <div
                className={`mt-2 border-t border-(--border) pt-2`}
                children={[
                  <p
                    className={`mb-1 text-center text-[10px] uppercase text-(--text)`}
                    children={`Hora`}
                  />,
                  <div
                    className={`flex justify-center gap-2`}
                    children={[
                      <Componente_KD_75_68
                        etiqueta={`Hora`}
                        opciones={b}
                        elegida={f}
                        onElegir={(e) => y(e, p || `00`)}
                      />,
                      <Componente_KD_75_68
                        etiqueta={`Minutos`}
                        opciones={x}
                        elegida={p}
                        onElegir={(e) => y(f || VD.slice(0, 2), e)}
                      />,
                    ]}
                  />,
                ]}
              />,
              <div
                className={`mt-2 flex items-center justify-between border-t border-(--border) pt-2`}
                children={[
                  <button
                    type={`button`}
                    onClick={() => l(!1)}
                    className={`text-xs font-medium text-(--accent) hover:underline`}
                    children={`Listo`}
                  />,
                  u && (
                    <button
                      type={`button`}
                      onClick={() => {
                        (t(``), l(!1));
                      }}
                      className={`text-xs text-(--text) hover:text-(--text-h)`}
                      children={`Quitar`}
                    />
                  ),
                ]}
              />,
            ]}
          />
        ),
      ]}
    />
  );
}
